import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackbarService } from './snack-bar/snack-bar.service';

@Injectable()
export class InternetConnectivityInterceptor implements HttpInterceptor {
  private snackbarService = inject(SnackbarService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!navigator.onLine) {
      this.snackbarService.showError('⚠️ No internet connection');
      return throwError(() => new Error('No internet connection'));
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          this.snackbarService.showError('Connection lost');
        }
        return throwError(() => error);
      })
    );
  }
}